import { Dialog, DialogActions, DialogContent } from '@mui/material';
import React, { useEffect, useState } from 'react'
import voucherPaymentItemServices from '../voucherPaymentItemServices';
import { useAlert } from '../../../../../../context/AlertContext';

function VoucherPaymentItemForm({voucherDetails, pendingAllocation, callBack}) {
    const [dialogStatus,setDialogStatus] = useState(false);
    const [pendingInvoiceList,setPendingInvoiceList] = useState([]);
    const [loading,setLoadingStatus] = useState(false);
    const [saving,setSavingStatus] = useState(false);

    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [amount, setAmount] = useState('');
    const [errorMsg, setErrorMsg] = useState('');

    const {AppAlert} = useAlert();


    const getPendingInvoiceList = () =>{
        setLoadingStatus(true);
        const fetchAPI = voucherDetails.voucherType ===  "Receipt"
            ? voucherPaymentItemServices.getSalesVoucherList 
            : voucherPaymentItemServices.getPurchaseVoucherList;
        
        // voucherDetails Ledger Id (ledgerId is one to whome we are paying, 
        // voucherDetails also have paymentLedgerId which from which we are paying
        fetchAPI(voucherDetails.ledgerId).then(res=>{ 
            setPendingInvoiceList(res.data);
        }).catch(error=>{

        }).finally(()=>{
            setLoadingStatus(false);
        })
    } 

    const handleOpen = () =>{
        setDialogStatus(true);
        getPendingInvoiceList();
    }


    const handleAmountChange = (e) =>{
        let _amount = e.target.value === "" ? "" : parseFloat(e.target.value);

        setErrorMsg("");

        if(_amount > selectedInvoice.pendingAmount) {
            setErrorMsg("Amount can not be greater then balance amount : "+selectedInvoice.pendingAmount);
        }

        
        if(_amount > pendingAllocation) {
            setErrorMsg("Max Allocatable Balance : "+pendingAllocation);
            return false;
        }
        

        setAmount(_amount);
    }
    
    const handleInvoiceDropdownChange = (e) => {
        let _invoice = pendingInvoiceList.find(inv => inv.id == e.target.value);
        setSelectedInvoice(_invoice || null);
        setAmount('');
        setErrorMsg('');
    };


    const allocateAmount = () =>{
        setSavingStatus(true);
        if(amount > selectedInvoice.pendingAmount) {
            setErrorMsg("Amount can not be greater then balance amount :  "+selectedInvoice.pendingAmount);
            return false;
        }
        if(amount > pendingAllocation) {
            setErrorMsg("Max Allocatable Balance : "+pendingAllocation);
            return false;
        }
        let payload = {
            paymentVoucherId: voucherDetails.id, // This Paymet / Receipt Voucher
            allocatedVoucherId: selectedInvoice.id, // Selected Invoice Id
            amount: amount
        }
        voucherPaymentItemServices.save(payload).then(res=>{
            AppAlert("Payment Allocated Successfully");
            setDialogStatus(false);
            callBack();
        }).catch(error=>{
            AppAlert(error.msg,"error")
        }).finally(()=>{
            setSavingStatus(false);
        })
    }

    return (
        <>
            <button className='btn btn-primary' onClick={handleOpen} >Allocate ({pendingAllocation}) </button>
            <Dialog open={dialogStatus} keepMounted onClose={() => setDialogStatus(false)} fullWidth maxWidth="sm" >
                <DialogContent>
                    <div className='row mt-3'>
                        <div className='col-md-12'>
                            <div className=" form-floating mb-3">
                                <select 
                                    className="form-select"
                                    onChange={handleInvoiceDropdownChange}
                                    defaultValue=""
                                    disabled={loading}
                                >
                                    <option value="" disabled>-- Choose Outstanding Bill --</option>
                                    {pendingInvoiceList.map(inv => 
                                        <option key={inv.id} value={inv.id}>
                                            {inv.voucherNo} | Bal: ₹{parseFloat(inv.pendingAmount).toFixed(2)})
                                        </option>
                                    )}
                                </select>
                                <label >Select Bill/Invoice</label>
                            </div>
                        </div>
                        
                        {selectedInvoice && (
                            <div className='col-md-12'>
                                <div className="p-2 mb-3 bg-light rounded border small text-muted">
                                    <div className="d-flex justify-content-between">
                                        <span>Original Total:</span>
                                        <strong>₹{parseFloat(selectedInvoice.grandTotal).toFixed(2)}</strong>
                                    </div>
                                    <div className="d-flex justify-content-between text-danger mt-1">
                                        <span>Balance:</span>
                                        <strong>₹{parseFloat(selectedInvoice.pendingAmount).toFixed(2)}</strong>
                                    </div>
                                    <div className="d-flex justify-content-between text-danger mt-1">
                                        <span>Max Allocatable Balance:</span>
                                        <strong>₹{parseFloat(pendingAllocation).toFixed(2)}</strong>
                                    </div>
                                </div>

                                {/* Allocation Input Field */}
                                <div className="mb-3">
                                    <label className="form-label  fw-semibold">Amount to Allocate</label>
                                    <div className="input-group">
                                        <span className="input-group-text">₹</span>
                                        <input
                                            type="number"
                                            className="form-control text-end fw-bold text-success"
                                            placeholder="0.00"
                                            value={amount}
                                            onChange={handleAmountChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </DialogContent>
                <DialogActions>
                    {errorMsg !== "" ? 
                        <div className="text-danger mt-2">{errorMsg}</div>
                        :
                        <button className='btn btn-primary' disabled={errorMsg !== ""} onClick={allocateAmount} >Submit</button>
                    }
                </DialogActions>
            </Dialog>
        </>
    )
}

export default VoucherPaymentItemForm